import { atom, selector, atomFamily } from 'recoil'

export const undoHistory = atom({
  key: 'undoHistory',
  default: [],
})

export const redoHistory = atom({
  key: 'redoHistory',
  default: [],
})

export const undoHistoryCurrentLength = atom({
  key: 'undoHistoryCurrentLength',
  default: null,
})

export const undoHistoryAction = atom({
  key: 'undoHistoryAction',
  default: false,
})

export const undoHistoryActionCount = atom({
  key: 'undoHistoryActionCount',
  default: 0,
})

export const undoHistoryCurrentIndex = atom({
  key: 'undoHistoryCurrentIndex',
  default: null,
})
